import { apiGet, apiPatch, apiPost } from '../client'

export type InterviewType = 'PHONE' | 'VIDEO' | 'IN_PERSON' | 'TECHNICAL' | 'PANEL'
export type InterviewStatus = 'SCHEDULED' | 'CONFIRMED' | 'COMPLETED' | 'CANCELLED' | 'RESCHEDULED' | 'NO_SHOW'

export interface ScheduleInterviewPayload {
  applicationId: string
  durationMinutes?: number
  scheduledAt: string
  timezone?: string
  type?: InterviewType
}

export interface UpdateInterviewPayload {
  cancelledReason?: string
  interviewerFeedback?: string
  meetingLink?: string
  notes?: string
  scheduledAt?: string
  status?: InterviewStatus
}

export interface Interview {
  applicationId: string
  durationMinutes?: number
  id: string
  interviewerEmail?: string
  interviewerName?: string
  meetingLink?: string
  notes?: string
  scheduledAt: string
  status: InterviewStatus
  timezone?: string
  type: InterviewType
}

/** Employer / school-admin only - creates the interview and flips the
 * application's status to INTERVIEW_SCHEDULED as a side effect. */
export const scheduleInterview = (payload: ScheduleInterviewPayload) => apiPost<Interview>('/interviews', payload)

export const listInterviews = () => apiGet<Interview[]>('/interviews')

export const getInterview = (id: string) => apiGet<Interview>(`/interviews/${id}`)

export const updateInterview = (id: string, payload: UpdateInterviewPayload) => apiPatch<Interview>(`/interviews/${id}`, payload)
